/**
 * PLP Notify Me — Klaviyo Back in Stock subscription.
 * If customer is logged in (has email), subscribe directly + toast.
 * If not logged in, show a simple email modal.
 */
(function () {
  'use strict';

  var KLAVIYO_KEY = (window.algoliaConfig && window.algoliaConfig.klaviyoKey) || 'WkiAic';

  function subscribeToBackInStock(email, variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + KLAVIYO_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-04-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$custom:::$default:::' + variantId } }
          }
        }
      })
    });
  }

  function showToast(message, type) {
    if (window.showInlineFormMessage) {
      window.showInlineFormMessage({ message: message, type: type || 'success' });
    }
  }

  function createModal(variantId) {
    var overlay = document.createElement('div');
    overlay.className = 'plp-notify-modal-overlay';
    overlay.innerHTML = [
      '<div class="plp-notify-modal">',
      '  <button class="plp-notify-modal__close" aria-label="Close">&times;</button>',
      '  <h3 class="plp-notify-modal__title">Get Notified When Back In Stock</h3>',
      '  <p class="plp-notify-modal__text">Enter your email and we\'ll notify you when this item is available again.</p>',
      '  <form class="plp-notify-modal__form">',
      '    <input class="plp-notify-modal__input" type="email" placeholder="Your email address" required />',
      '    <button class="plp-notify-modal__submit" type="submit">Notify Me</button>',
      '  </form>',
      '  <p class="plp-notify-modal__error"></p>',
      '</div>'
    ].join('');

    overlay.querySelector('.plp-notify-modal__close').addEventListener('click', function () {
      overlay.remove();
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) overlay.remove();
    });

    overlay.querySelector('.plp-notify-modal__form').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = overlay.querySelector('.plp-notify-modal__input');
      var errorEl = overlay.querySelector('.plp-notify-modal__error');
      var email = input.value.trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        errorEl.textContent = 'Please enter a valid email address.';
        return;
      }
      errorEl.textContent = '';
      var btn = overlay.querySelector('.plp-notify-modal__submit');
      btn.disabled = true;
      btn.textContent = 'Submitting...';

      subscribeToBackInStock(email, variantId).then(function (res) {
        if (res.ok || res.status === 202) {
          showToast('You will be notified when this item is back in stock.');
          overlay.remove();
        } else {
          errorEl.textContent = 'Something went wrong. Please try again.';
          showToast('Something went wrong. Please try again.', 'error');
          btn.disabled = false;
          btn.textContent = 'Notify Me';
        }
      }).catch(function () {
        errorEl.textContent = 'Something went wrong. Please try again.';
        btn.disabled = false;
        btn.textContent = 'Notify Me';
      });
    });

    document.body.appendChild(overlay);
    overlay.querySelector('.plp-notify-modal__input').focus();
  }

  window.PlpNotifyMe = function (variantId) {
    var email = (window.algoliaConfig && window.algoliaConfig.customerEmail) || '';
    if (email) {
      subscribeToBackInStock(email, variantId).then(function (res) {
        if (res.ok || res.status === 202) {
          showToast('Thanks for subscribing! You will be notified when this item is back in stock.');
        } else {
          showToast('Something went wrong. Please try again.', 'error');
        }
      }).catch(function () {
        showToast('Something went wrong. Please try again.', 'error');
      });
    } else {
      createModal(variantId);
    }
  };
})();
